/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Button, DownloadIcon } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";

export default function ProductInfoSheetButton({ product, ...rest }) {
  if (!product?.infoSheet?.url) return null;
  return (
    <Button
      href={product.infoSheet.url}
      target="_blank"
      rel="noopener noreferrer"
      variant="outline"
      sx={{ textAlign: "center" }}
      {...rest}
    >
      <DownloadIcon
        size="small"
        sx={{ marginRight: 2, color: "currentColor" }}
      />
      <Trans>Download info sheet</Trans>
    </Button>
  );
}

export const fragment = graphql(`
  fragment bb_ProductInfoSheetButton on Bottlebooks_RegisteredProduct {
    infoSheet(templateId: "Bottlebooks/InfoSheetWithQRCodes") {
      url
    }
  }
`);

ProductInfoSheetButton.fragment = gql`
  fragment ProductInfoSheetButton on RegisteredProduct {
    infoSheet(templateId: "Bottlebooks/InfoSheetWithQRCodes") {
      url
    }
  }
`;
